import React, { useEffect } from "react";
import Popup from '../Component/Popup'
import HomeSlider from '../Component/HomeSlider'
import TopperXII from '../Component/TopperXII'
import TopperX from '../Component/TopperX'
import Birthday from '../Component/Birthday'
import Events from '../Component/Events'
import News from '../Component/News'
import Campuscare from '../Component/Campuscare'
import OnlineRegistration from '../Component/OnlineRegistration'
// import Facilities from'../Component/Facilities'
import Gallery from '../Component/Gallery'
// import Message from '../Component/Message'
import PageLoader from '../Component/PageLoader'
import { Link } from 'react-router-dom'
import Message from '../Component/Message'
import LazyLoad from "react-lazyload";
const Home = () => {
 
  return (
    <>
<PageLoader />
      <Campuscare />

      <Popup />
      <OnlineRegistration />

      {/* <Popup /> */}

      <div className='container-fluid'>
        <div className='row'>
          <div className='col-lg-3 col-md-12 padding-0 order-lg-1 order-md-2'>
            <div className="about-news">
              <News />
            </div>
          </div>
          <div className='col-lg-9 col-md-12 padding-0 order-1'>
            <HomeSlider />
          </div>
        </div>
      </div>


      <div className="aboutmidsec padded-sec">
        <div className='button'>
          <p><Link to="/Tc" target="_blank">Transfer Certificate</Link></p>
        </div>
        <div className='button'>

          <p> <Link to="https://entab.online/SFSASR" target="_blank">Online Payment</Link></p>
        </div>
        <div className='button'>
          <p> <Link to="https://portalguidelines.campuscare.info/index.html#SFSASR" target="_blank">Parent Guidelines</Link></p>
        </div>

        <div className='button light'>
          <p><Link to="https://entab.online/SFSASR" target="_blank">Alumni Registration</Link></p>
        </div>
        <div className='button'>
          <p><Link to="/ERPSoftware"> ERP Software </Link></p>
        </div>
        <div className='button'>
          <p><Link to="/Admission">Admission </Link></p>
        </div>
      </div>

      <div className='aboutSection padded-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-12 abt-content-block'>
              <div className='abt-content section-title'>
                <div className='title'>
                  <p>ABOUT US</p>
                  <h2>St. francis school , <span>Amritsar</span></h2>
                </div>
                <p>This School is owned and administered by the <span className="clr-red">diocese of Jalandhar</span>, a registered charitable society that conducts several flourishing schools <span className="clr-red">all over Punjab and certain parts of H.P. </span>This is also a minority institution with all its privileges guaranteed by the Supreme Contitution of India, under the Articles 29, 30 (1). His Excellency the Bishop of Jalandhar is the patron of this school and the president of the society.The main aim of the school is to provide a sound, value base and emancipation education, designed to train its pupils to live for God and country, through their activities, be it moral, spiritual, intellectual, social or professional. It is student friendly and encourages analytical, creative and independent perspectives, all round development, positive thinking attitude and sound domain of knowledge with particular applications of it.</p>
                <button className='button'><Link to="/About"> READ MORE </Link></button>
              </div>
            </div>
            <div className='col-lg-7'>
              <div className='about-img'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/video.png" className='img-fluid' alt="St francis school, Amritsar" /></LazyLoad>
              </div>
            </div>

            <div className='col-lg-5'>
               <div className='about-flex'>
                <LazyLoad> <img src='https://webapi.entab.info/api/image/SFSAP/public/Images/chairman.png' alt="St francis school, Amritsar" /></LazyLoad>
                <div>
                  <p>Most Rev. Fr. Thomas Kolenchery</p>
                  <p><span>CHAIRMAN OF JALANDHAR DIOCESE</span></p>
                </div>
              </div>  
              <div className='about-flex'>
                <LazyLoad> <img src='https://webapi.entab.info/api/image/SFSAP/public/Images/founder.png' alt="St francis school, Amritsar" /></LazyLoad>
                <div>
                  <p>MOST REV. JOSE SEBESTIAN T</p>
                  <p><span>BISHOP OF JALANDHAR DIOCESE</span></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className='four-block padded-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-lg-3 col-md-6'>
              <div className='four-blk'>
                <LazyLoad><img src="https://webapi.entab.info/api/image/SFSAP/public/Images/mission.gif" alt="St francis school, Amritsar" /></LazyLoad>
                <h3>OUR MISSION</h3>
                <p>To inculcate in the young minds the spirit of striving hard for perfection, and to provide a congenial atmosphere to nurture them. We endeavour hard that each child may bring out the best in himself/herself.</p>

              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='four-blk'>
                <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/vision.gif" alt="St francis school, Amritsar" /></LazyLoad>
                <h3>OUR VISION</h3>
                <p>To enrich the journey of education by imbibing rich ethical values in students and to exhibit excellence in all spheres. We believe that a curriculum with a global dimension will help the students to face the challenges in this technocratic world.</p>

              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='four-blk'>
                <LazyLoad>  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/motto.gif" alt="St francis school, Amritsar" /></LazyLoad>
                <h3>OUR MOTTO</h3>
                <p>Children will be enlightened intellectually morally, socially, professionally and spiritually. Although it is a Christian Minority School, every student is encouraged to practice his/her religion.</p>

              </div>
            </div>
            <div className='col-lg-3 col-md-6'>
              <div className='four-blk'>
                <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/aim.gif" alt="St francis school, Amritsar" /></LazyLoad>
                <h3>OUR AIM</h3>
                <p>The aim of the school is to impart quality education designed for the all round development of the child. The students will be prepared for their future duties by a careful cultivation of their minds and hearts.</p>

              </div>
            </div>

            <div className='col-lg-12'>
              <button className='button'><Link to="/Visionmission">READ MORE </Link></button>
            </div>
          </div>
        </div>
      </div>

      <div className="toper-birthday padded-sec">
        <div className="container-fluid section-title">
          <div className="row">
            <div className="col-lg-8">
              <div className='top-ach'>
                <div className='title'>
                  <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/tpr.gif" alt="St francis school, Amritsar" /></LazyLoad>
                  <p>OUR SHINING STARS</p>
                  <h2>TOP <span>ACHIEVERS</span></h2>

                </div>
                <div className='toper-block'>
                  <div>
                    <h2>TOPPERS X</h2>
                    <TopperX />
                    <button className='button'><Link to="/TopperX"> View All </Link></button>
                  </div>
                  <div>
                    <h2> TOPPERS XII</h2>
                    <TopperXII />
                    <button className='button'><Link to="/TopperXII"> View All </Link></button>
                  </div>

                </div>
              </div>


            </div>
            <div className="col-lg-4 birthday_section">
              <div className='title'>
                <LazyLoad> <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/birthday.gif" alt="St francis school, Amritsar" /></LazyLoad>
                <p>STARS OF THE DAY</p>
                <h2>HAPPY <span> BIRTHDAY</span></h2>

              </div>
              <Birthday />

            </div>
          </div>
        </div>
      </div>
      <div className='message_section padded-sec'>
        <div className='container-fluid'>
          <div className='row'>
            <div className="col-lg-12 section-title">
              <div className='title'>
                <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/message.gif" className="img-fluid" alt="St francis school, Amritsar" />
                <p>FROM THE DESK OF</p>
                <h2>MESSAGE SECTION</h2>
              </div>
            </div>
            <div className='col'>
              <Message />
            </div>
          </div>
        </div>
      </div>

      <div className="event padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className="col-lg-12 section-title">
              <div className='title'>
                <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/calender.gif" className="img-fluid" alt="St francis school, Amritsar" />
                <p>happening in  our school</p>
                <h2>LATEST <span> EVENTS</span></h2>
              </div>
            </div>
            <div className="col-lg-12">
              <Events />

            </div>
          </div>
        </div>
      </div>

      <div className="homegallery padded-sec">
        <div className="container-fluid fulwidth">
          <div className="row">
            <div className='col-md-12 section-title'>
              <div className='title'>
                <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/gallery.gif" className="img-fluid" alt="St francis school, Amritsar" />
                <p>Some Precious Moments</p>
                <h2>Photo Gallery</h2>
              </div>
            </div>
            <div className="col-lg-12">

              <Gallery />
              <button className='button'><Link to="/gallery"> View All </Link></button>
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Home
